export const isNumber = (num) => Number.isFinite(num);
